/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect } from 'react';

import { useRetracked } from 'js/lib/retracked';

import { PageGridContainer, breakpoints } from '@coursera/cds-core';

import PromoNotificationBar from 'bundles/coursera-plus/components/elevateLTV/PromoNotificationBar';

import _t from 'i18n!nls/coursera-plus';

const styles = {
  container: css`
    margin-top: var(--cds-spacing-400);
    margin-bottom: var(--cds-spacing-300);

    ${breakpoints.down('sm')} {
      margin: var(--cds-spacing-200) 0;
    }
  `,
  contentWrapper: css`
    width: 100%;
    padding: 20px;
  `,
};

const S12nToCourseraPlusUpgradeNotification = () => {
  const retrackedTrack = useRetracked();

  useEffect(() => {
    retrackedTrack({
      trackingData: {},
      trackingName: 's12n_to_coursera_plus_upgrade_modal_success',
      action: 'view',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageGridContainer css={styles.container}>
      <div css={styles.contentWrapper}>
        <PromoNotificationBar
          title={_t('Welcome to Coursera Plus')}
          subtitle={_t("You've unlocked thousands of learning programs, guidance from Coursera Coach, and more.")}
        />
      </div>
    </PageGridContainer>
  );
};

export default S12nToCourseraPlusUpgradeNotification;
